
export default {
  20520001: 'ATERRO',
  20520002: 'VALORIZAÇÃO',
  20520003: 'INCINERAÇÃO',
  20520004: 'AUTOCLAVE',
  20520005: 'TRIAGEM',
  20520006: 'EFLUENTES'
}
